'use strict';

var controls = angular.module('saturn.map.controls', []);

var ControlsDirective = require('./ControlsDirective');

// ## Services, Factories, and Providers
// none....

// ## Directives
controls.directive('sbMapControls', ControlsDirective);



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/controls/index.js